export default function() {
  this.loadCart()
}
